import api from './index';
//
let exports = {};

// ============================ 设备领用/归还 ==========================

exports.getAppturnVoucherItemList = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/item/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取设备领用/归还--详情
exports.getShopDeviceAppturnVoucherIndcludeItems = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/info/include/items/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取设备领用/归还--详情
exports.getShopDeviceAppturnVoucherInfo = function (params, callback) {
    api.get('/asset/vchr/appturn/voucher/info/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取设备领用/归还分页列表
exports.getShopDeviceAppturnVoucherList = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存设备领用/归还单
exports.saveShopDeviceAppturnVoucher = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.modifyShopDeviceAppturnVoucher = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/modify/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 申请设备领用/归还单
exports.applyShopDeviceAppturnVoucher = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 审核设备领用/归还单
exports.aduitShopDeviceAppturnVoucher = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/aduit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 删除设备领用/归还单
exports.deleteShopDeviceAppturnVoucher = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 子设备领用 - 生成领用单
exports.saveShopDeviceReceiveVoucher = function (data, callback) {
    api.post('/asset/vchr/receive/voucher/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 子设备归还 - 生成归还单
exports.saveShopDeviceReturnVoucher = function (data, callback) {
    api.post('/asset/vchr/return/voucher/save/do')
        .data(data)
        .done(callback)
        .go();
};

exports.getAppturnVoucherItemDepartStatis = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/item/depart/statis/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getAppturnVoucherItemDepartStatisForExport = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/item/depart/statis/export/do')
        .data(data)
        .done(callback)
        .go();
};
exports.getAppturnVoucherItemDepartStaffStatis = function (data, callback) {
    api.post('/asset/vchr/appturn/voucher/item/depart/staff/statis/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getAppturnVoucherItemDepartStaffStatisForExport = function (data, callback) {
    api.get('/asset/vchr/appturn/voucher/item/depart/staff/statis/export/do')
        .params(data)
        .done(callback)
        .go();
};

exports.getShopDeviceAppturnVoucherApplyStateInitialTodoCount = function (data, callback) { //待办-领用(未申请)
    api.get('/asset/vchr/appturn/voucher/applyState/initial/to-do/count/get')
        .params(data)
        .done(callback)
        .go();
};
exports.getShopDeviceAppturnApplyStateAppliedVoucherTodoCount = function (data, callback) { //待办-领用（申请未审核）
    api.get('/asset/vchr/appturn/voucher/applyState/applied/to-do/count/get')
        .params(data)
        .done(callback)
        .go();
};
exports.getShopDeviceAppturnVoucherAuditStateAuditFailTodoCount = function (data, callback) { //待办-领用(审核未通过)
    api.get('/asset/vchr/appturn/voucher/auditState/auditFail/to-do/count/get')
        .params(data)
        .done(callback)
        .go();
};
exports.getShopDeviceReturnVoucherApplyStateInitialTodoCount = function (data, callback) { //待办-归还(未申请)
    api.get('/asset/vchr/return/voucher/applyState/initial/to-do/count/get')
        .params(data)
        .done(callback)
        .go();
};
exports.getShopDeviceReturnVoucherAuditStateAuditFailTodoCount = function (data, callback) { //待办-归还(审核未通过)
    api.get('/asset/vchr/return/voucher/auditState/auditFail/to-do/count/get')
        .params(data)
        .done(callback)
        .go();
};
exports.getShopDeviceReturnApplyStateAppliedVoucherTodoCount = function (data, callback) { //待办-归还（申请未审核）
    api.get('/asset/vchr/return/voucher/applyState/applied/to-do/count/get')
        .params(data)
        .done(callback)
        .go();
};

// ============================= 清理单据 ============================
// 分页查询清理单据
exports.getShopDeviceClearVoucherList = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 固定资产清理单查询 -- 包含单项信息
exports.getShopDeviceClearVoucherIncludeItems = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/get/include/items')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 固定资产清理单查询 - 仅单据信息
exports.getShopDeviceClearVoucher = function (params, callback) {
    api.get('/asset/vchr/clear/voucher/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 固定资产清理单项-分页列表
exports.getShopDeviceClearItemList = function (data, callback) {
    api.post('/asset/vchr/clear/item/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存修改报废单据
exports.saveShopDeviceClearVoucher = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 申请清理单据
exports.applyShopDeviceClearVoucher = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 审核清理单据
exports.aduitShopDeviceClearVoucher = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/aduit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 删除清理单据
exports.deleteShopDeviceClearVoucher = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 解除清理单据
exports.updateShopDeviceClearVoucherUnBnbind = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/item/vendorUkno')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.doClearedShopDevice = function (data, callback) {
    api.post('/asset/vchr/cleared/set/do')
        .data(data)
        .done(callback)
        .go();
};

exports.doClearShopDeviceBatchStock = function (data, callback) {
    api.post('/asset/vchr/batch/stock/cleared/set/do')
        .data(data)
        .done(callback)
        .go();
};

exports.getShopDeviceClearVoucherApplyStateInitialTodoCount = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/applyState/initial/to-do/count/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getShopDeviceClearVoucherAuditStateAuditFailTodoCount = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/auditState/auditFail/to-do/count/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getShopDeviceClearVoucherApplyStateAppliedTodoCount = function (data, callback) {
    api.post('/asset/vchr/clear/voucher/applyState/applied/to-do/count/get')
        .data(data)
        .done(callback)
        .go();
};

// ===================== 资产调拨单 =========================

// 调拨单查询
exports.getShopDeviceTransVoucher = function (data, callback) {
    api.get('/asset/vchr/trans/voucher/get')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 根据id查询调拨单
exports.getShopDeviceTransVoucherById = function (params, callback) {
    api.post('/asset/vchr/trans/voucher/get/by/id')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 设备调拨列表
exports.getShopDeviceTransVoucherList = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceTransVoucherNoPageList = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/noPage/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存调拨单
exports.saveShopDeviceTransVoucher = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存并申请调拨单
exports.doSubmitDeviceTransVoucher = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/submit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 申请调拨单
exports.applyShopDeviceTransVoucher = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 审核调拨单
exports.aduitShopDeviceTransVoucher = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/aduit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 确认调拨单
exports.confirmShopDeviceTransVoucher = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/confirm/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 作废调拨单
exports.doInvalidTransVoucher = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/invalid/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 删除调拨单
exports.deleteShopDeviceTransVoucher = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 保存调拨单附件
exports.saveShopDeviceTransFile = function (data, callback) {
    api.post('/asset/vchr/trans/file/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询调拨单附件
exports.getShopDeviceTransFileListByVoucherId = function (data, callback) {
    api.get('/asset/vchr/trans/file/get/by/voucherId')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 查询调拨单附件
exports.getShopDeviceTransVoucherAppStateTodoCount = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/applyState/to-do/count/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询调拨单附件
exports.getShopDeviceTransVoucherConfirmTodoCount = function (data, callback) {
    api.get('/asset/vchr/trans/voucher/confirm/to-do/count/get')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ========================= 调拨单项 ====================

// 调拨单项查询-带分页
exports.getShopDeviceTransVoucherItemList = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/item/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceTransVoucherItemXList = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/item/x/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 调拨单项查询
exports.getShopDeviceTransVoucherItemAutoList = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/item/list/auto/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ======================== 调拨单审核记录 =================

// 调拨单审核记录
exports.getShopDeviceTransAuditRecByVoucherId = function (data, callback) {
    api.get('/asset/vchr/trans/voucher/audit/rec/get/voucherId')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ============================== （零售）门店设备盘点单 ==========================




exports.exportShopDeviceStockCheckVoucher = function (params, callback) {
    api.get('/asset/vchr/stock/check/voucher/export/get/by/id')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceStockCheckVoucherListByIds = function (params, callback) {
    api.post('/asset/vchr/stock/check/voucher/list/by/ids')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceStockCheckVoucherItems = function (params, callback) {
    api.post('/asset/vchr/stock/check/voucher/items/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};


//（零售）门店设备盘点单-指定结果处理执行人
exports.updateShopDeviceStockCheckVoucherAssignDoneStaff = function (params, callback) {
    api.post('/asset/vchr/stock/check/voucher/update/assignDoneStaff/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};


//（零售）门店设备盘点单-申请
exports.doApplyShopDeviceStockCheckVoucher = function (params, callback) {
    api.post('/asset/vchr/stock/check/voucher/apply/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单条目-根据id
exports.getShopDeviceStockCheckItemById = function (params, callback) {
    api.post('/asset/vchr/stock/check/voucher/item/get/by/id')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项根据id查询
exports.getShopDeviceStockHandleItemsById = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/get/by/id')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项根据voucherItemId查询
exports.getShopDeviceStockHandleItemsByVoucherItemId = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询（零售）门店设备盘点处理项是否全部审核通过
exports.getShopDeviceStockHandleItemsAuditPassFlagByVoucherId = function (params, callback) {
    api.get('/asset/vchr/stock/handle/item/auditPassFlag/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项-保存
exports.saveShopDeviceStockHandleItem = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/save/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项-修改
exports.updateShopDeviceStockHandleItem = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/update/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项-删除
exports.deleteShopDeviceStockHandleItemById = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/delete/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项-审核
exports.doAuditShopDeviceStockHandleItem = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/audit/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项-执行-根据id
exports.doShopDeviceStockHandleItemDone = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/done/do/by/id')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// （零售）门店设备盘点处理项-执行-根据voucherId
exports.doShopDeviceStockHandleItemDoneByVoucherId = function (params, callback) {
    api.post('/asset/vchr/stock/handle/item/done/do/by/voucherId')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};



// 处理结束-操作
exports.doFinishedHandleDeviceStockCheck = function (params, callback) {
    api.post('/asset/vchr/stock/handle/finished/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 查询盘点明细
exports.getShopDeviceStockCheckItemByVoucherId = function (data, callback) {
    api.post('/asset/vchr/stock/check/voucher/item/list/get/voucherId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询盘点结果
exports.getShopDeviceStockHandleItemByVoucherId = function (data, callback) {
    api.get('/asset/vchr/stock/handle/item/list/get/voucherId')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 查询盘点结果
exports.getShopDeviceStockHandleItemsByVoucherId = function (data, callback) {
    api.post('/asset/vchr/stock/handle/items/get/voucherId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询盘点结果
exports.getHandleItemWayList = function (data, callback) {
    api.get('/asset/vchr/stock/handle/item/way/get/voucherId')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询盘点结果
exports.getShopDeviceStockHandleItemsByFilter = function (data, callback) {
    api.post('/asset/vchr/stock/handle/item/list/get/by/filter')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ============================= 报废单据 ============================
// date 2019-02-28 @auther libin @desc 新增报废单据
// 分页查询报废单据
exports.getShopDeviceScrapVoucherList = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 固定资产出入库单查询
exports.getShopDeviceScrapVoucherById = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/get/by/id')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 计算报废损失金额
exports.getShopDeviceScrapVoucherItemNetWorth = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/item/netWorth/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存修改报废单据
exports.saveShopDeviceScrapVoucher = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存修改报废单据项
exports.saveShopDeviceScrapVoucherItem = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/item/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存并申请单据
exports.doSubmitDeviceScrapVoucher = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/submit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 申请报废单据
exports.applyShopDeviceScrapVoucher = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 审核报废单据
exports.aduitShopDeviceScrapVoucher = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/aduit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 报废单-重新执行
exports.saveScrapAssetAuditPassAgain = function (data, callback) {
    api.post('/asset/vchr/scrap/asset/aduit/pass/again')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 报废单作废
exports.updateShopDeviceScrapVoucherInvalid = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/invalid/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 删除报废单据
exports.deleteShopDeviceScrapVoucher = function (data, callback) {
    api.post('/asset/vchr/scrap/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 查询单个报废单
exports.getShopDeviceScrapVoucher = function (params, callback) {
    api.get('/asset/vchr/scrap/voucher/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 查询报废单项
exports.getShopDeviceScrapItemList = function (data, callback) {
    api.post('/asset/vchr/scrap/item/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceScrapItemXList = function (data, callback) {
    api.post('/asset/vchr/scrap/item/x/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceScrapVoucherApplyStateAppliedTodoCount = function (data, callback) {   // 申请未审核
    api.post('/asset/vchr/scrap/voucher/applyState/applied/to-do/count/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceScrapVoucherApplyStateInitialTodoCount = function (data, callback) {   // 未申请未审核
    api.post('/asset/vchr/scrap/voucher/applyState/initial/to-do/count/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceScrapVoucherAuditStateAuditFailTodoCount = function (data, callback) {   // 申请审核不通过
    api.post('/asset/vchr/scrap/voucher/auditState/auditFail/to-do/count/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.doScrapVoucherImpCheck = function (data, callback) {   // 报废单检查
    api.post('/asset/vchr/scrap/voucher/imp/check')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.saveScrapVoucherImpDo = function (data, callback) {   // 报废单逐条保存
    api.post('/asset/vchr/scrap/voucher/imp/save')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// --------------------- 出入库记录 ----------------------
// 保存出入库记录
exports.saveShopDeviceIoVoucher = function (params, callback) {
    api.post('/asset/vchr/io/voucher/save/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 列表查询
exports.getShopDeviceIoVoucherList = function (data, callback) {
    api.post('/asset/vchr/io/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 固定资产出入库单查询
exports.getShopDeviceIoVoucherById = function (data, callback) {
    api.get('/asset/vchr/io/voucher/get/by/id')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceIoRecordFiscalAccList = function (data, callback) {
    api.post('/asset/vchr/io/item/page/list/get/by/filter')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// =================== （零售）店设备出入库记录 =========================
exports.getShopDeviceIoRecordList = function (data, callback) {
    api.post('/asset/vchr/io/record/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 固定资产出入库单项分页
exports.getShopDeviceIoItemPageList = function (data, callback) {
    api.post('/asset/vchr/io/item/page/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 固定资产出入库单查询
exports.getShopDeviceIoVoucher = function (data, callback) {
    api.get('/asset/vchr/io/voucher/get')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getShopDeviceIoRecord = function (params, callback) {
    api.get('/asset/vchr/io/record/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};



// 获取出入库记录中分类的信息
exports.getShopDeviceIoRecordCatNameByFilter = function (data, callback) {
    api.post('/asset/vchr/io/record/cat/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
}

//设备盘点单生成项-分页查询
exports.getDeviceCheckGenItemList = function (params, callback) {
    api.post('/asset/vchr/device/check/gen/item/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
//设备盘点单生成任务-单条执行
exports.doneDeviceCheckGenItem = function (params, callback) {
    api.post('/asset/vchr/device/check/gen/item/done')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
//设备盘点单生成任务项-设置抽盘负责人
exports.updateDeviceCheckGenItemSpotPrincipal = function (params, callback) {
    api.post('/asset/vchr/device/check/gen/item/spotPrincipal/update')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 根据调入、调出机构获取调拨逻辑类型
exports.getShopDeviceTransVoucherAllotAcntType = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/allot/acnt/type/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// --------- 报损相关 -----------
exports.getShopDeviceRuinVoucherById = function (params, callback) {
    api.get('/asset/vchr/ruin/voucher/info/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getShopDeviceRuinVoucherList = function (data, callback) {
    api.post('/asset/vchr/ruin/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveShopDeviceRuinVoucher = function (data, callback) {
    api.post('/asset/vchr/ruin/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateShopDeviceRuinVoucher = function (data, callback) {
    api.post('/asset/vchr/ruin/voucher/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.applyShopDeviceRuinVoucher = function (data, callback) {
    api.post('/asset/vchr/ruin/voucher/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.aduitShopDeviceRuinVoucher = function (data, callback) {
    api.post('/asset/vchr/ruin/voucher/aduit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteShopDeviceRuinVoucher = function (data, callback) {
    api.post('/asset/vchr/ruin/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getShopDeviceRuinItemList = function (data, callback) {
    api.post('/asset/vchr/ruin/voucher/item/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//  ===== 验收单 =====
exports.getTransReceiptOrDirectQuantity = function (data, callback) {
    api.post('/asset/vchr/trans/receipt/quantity/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getTransReceiptList = function (data, callback) {
    api.post('/asset/vchr/trans/receipt/pages/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getTransReceiptInfo = function (data, callback) {
    api.post('/asset/vchr/trans/receipt/info/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveTransReceiptInfo = function (data, callback) {
    api.post('/asset/vchr/trans/receipt/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 调拨验收单作废操作
exports.updateTransReceiptInvalid = function (data, callback) {
    api.post('/asset/vchr/trans/receipt/invalid/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveShopDeviceTransVoucherForDirectFlag = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/save/for/direct/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateShopDeviceTransVoucherForDirectConfirm = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/update/confirm/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 资产调拨业务明细
exports.getAssetTransBizdtlListByFilter = function (data, callback) {
    api.post('/asset/vchr/trans/voucher/bizdtl/page/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doTransReceiptFiscalSsp = function (data, callback) {
    api.post('/asset/vchr/trans/receipt/fiscalSsp/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ------------------- 资产处置单 --------------------

// 资产处置单列表
exports.getDevcDisposeVoucherList = function (data, callback) {
    api.post('/asset/vchr/dispose/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取处置单详情
exports.getDevcDisposeVoucher = function (params, callback) {
    api.get('/asset/vchr/dispose/voucher/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 获取资产处置单条目列表
exports.getDevcDisposeItemList = function (data, callback) {
    api.post('/asset/vchr/dispose/item/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 保存资产处置单
exports.saveDevcDisposeVoucher = function (data, callback) {
    api.post('/asset/vchr/dispose/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 资产处置单申请操作
exports.applyDevcDisposeVoucher = function (data, callback) {
    api.post('/asset/vchr/dispose/voucher/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 资产处置单审核操作
exports.auditDevcDisposeVoucher = function (data, callback) {
    api.post('/asset/vchr/dispose/voucher/audit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 删除资产处置单
exports.deleteDevcDisposeVoucher = function (data, callback) {
    api.post('/asset/vchr/dispose/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/assetVchr.js
// module id = 16
// module chunks = 0